<template>
    <div>
        <div>
            {{ label }}
        </div>

        <div class="my-2 d-flex align-center">
            <align-selector :editor="editor"></align-selector>
            <link-creator @create="insertContent"></link-creator>
        </div>

        <editor-content
            v-if="editor"
            :editor="editor"
        ></editor-content>
    </div>
</template>

<script>
import { Editor, EditorContent } from '@tiptap/vue-2'
import StarterKit from '@tiptap/starter-kit'
import Link from '@tiptap/extension-link'
import TextAlign from '@tiptap/extension-text-align'
import LinkCreator from './LinkCreator.vue'
import AlignSelector from './AlignSelector.vue'

export default {
    props: {
        label: {
            type: String,
            required: true,
        },
    },

    components: {
        AlignSelector,
        LinkCreator,
        EditorContent,
    },

    data: () => ({
        editor: null,
    }),

    methods: {
        insertContent(content) {
            this.editor.chain().focus().insertContent(content).run()
        },
    },

    mounted() {
        this.editor = new Editor({
            content: null,
            extensions: [
                StarterKit,
                Link.configure({
                    openOnClick: false,
                    linkOnPaste: false,
                }),
                TextAlign.configure({
                    types: ['paragraph'],
                }),
            ],
            injectCSS: false,
            onUpdate: () => {
                this.$emit('input', this.editor.getJSON())
            },
        })
    },

    beforeDestroy() {
        this.editor.destroy()
    },
}
</script>

<style lang="css">
.ProseMirror {
    border: 1px solid blue;
    padding: 4px;
}
</style>
